/**
 * Sharing an invoice, as plain functions the sheet and a test can both read.
 * No imports, so Node's test runner can pin the behaviour without a bundler.
 */

/**
 * WhatsApp's `wa.me` wants digits only, with the country code and no plus:
 * "+91 98406 64027" -> "919840664027". A ten-digit number with no code is an
 * Indian mobile, the only kind this book's customers have, and gets 91 in
 * front; anything longer is taken as complete. Null when there is nothing
 * to dial - WhatsApp then opens on the person's own contacts.
 */
export function whatsappNumber(phone: string | null | undefined): string | null {
  const digits = (phone ?? '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length === 10) return `91${digits}`;
  // "0 98406 64027": the trunk zero is not part of the international form.
  if (digits.length === 11 && digits.startsWith('0')) return `91${digits.slice(1)}`;
  return digits;
}
